/* eslint-disable quotes */
// pt-PT.js
export const portugues_portugal = {
  start: "Começar",
  configurations: "Configurações",
  ramdom: "Modo de Jogo Aleatório",
  vibration: "Vibração :",
  startgame: "Início do Jogo",
  save: "Salvar",
  delete: "Excluir",
  update: "Atualização",
  lets: "Vamos jogar",
  permanentbuy: "Compra Permanente",
  signature: "Subscrição mensal",
  signatureano: "Subscrição anual",
  small: "Aqui podes usar teu nome verdadeiro... ou um apelido:)",
  text1: "Obtenha acesso Premium e garanta todas as atualizações",
  text2: "Subscrever pode aceder à versão Premium sempre que quiser",
  gender: "Género",
  male: "Homem  ",
  female: "Fêmea",
  ambos: "Ambos",
  fechar: "Fechar",
  sexualorientation: "Orientação sexual",
  heterosexual: "Heterossexual",
  homosexual: "Gay",
  bisexual: "Bissexual",
  chooseavatar: "Escolha seu avatar",
  Participants: "Participantes",
  participant: "Inscrição de Participantes",
  name: "Nome",
  choosecategory: "Escolha categorias",
  categories: "Categorias",
  light: "Leve",
  preliminary: "Preliminares",
  oral: "Oral",
  anal: "Anal",
  hot: "Quente",
  extreme: "Extremo",
  vd: "Verdade ?",
  dare: "Desafios ?",
  truth: "Verdade",
  time: "Hora",
  createMyChallenges: "Criar os meus desafios",
  chosen: "Selecionado",
  text3: "Deixe o amor fluir em tu",
  text4: "Prepare-se para viver intensamente",
  close: "Fechar",
  sele: "Selecione uma opção",
  dev: "Desenvolvido por Dev12BR",
  game: "Jogo",
  get: "Comprar - R$ 34,99",
  sign: "Sinal - R$ 5,99",
  next: "A SEGUIR",
  config1: "Por que devo comprar a versão Premium?",
  config2: "Categorias únicas e mais de 800 novos desafios",
  config3: "Sem anúncios",
  config4: "Escolha avatares para aumentar",
  config5: "Crie os seus próprios desafios ",
  config6: "Apoia o desenvolvimento do jogo",
  config7: "Por que o jogo é caro?",
  config8:
    "Para desenvolver o jogo requer tempo! Desta forma, apoias o jogo ajuda-nos a melhorar e a atualizar o jogo.",
  config9: "Crie e edite os seus desafios",
  age: `Este jogo é só para adultos, por isso deves ter pelo menos 18 anos. Ao selecionar "Sim" estas de acordo com os termos de utilização e política de privacidade. 

    Este jogo é adequado para casais, por isso tens de jogar com pelo menos um parceiro.
    
    Não é uma aplicação de encontros, é uma forma de brincar com o teu parceiro.
    `,
  config10: "Categorias exclusivas",
  config11: "+ 800 novos desafios",
  assessment:
    "Por favor, avalie adicionando um comentário sobre a app. O seu feedback é muito importante para nós para manter o jogo da melhor forma possível.",
  agree: "Sim, tenho mais de 18 anos.",
  noAgree: "Encerrar aplicação",
  apoio1: "Apoiar o desenvolvimento através da subscrição da versão premium",
  apoio2: "Não se esqueça de classificar a app na Loja",
  apoio3: "Ter acesso a todas as funcionalidades exclusivas da versão Premium",
  apoio4: "Livre-se deste banner - Compre a versão Premium",
  version: "Versão Premium",
  version1: "Versão Premium",
  alert1: "Inscreva utilizadores para jogar",
  alert2: "Registre pelo menos mais um utilizador para jogar",
  alert3: "Selecione pelo menos uma categoria",
  alert4: `🔥 Há participantes sem parceiros. Ter pelo menos dois participantes para cada género sexual 🔞. 
        
Ex: Dois heterossexuais, ou 2 homossexuais.`,
  tituloAlert1: "⚠️ O jogo ja vai começar 😜",
  tituloAlert2:
    "⚠️ Pena 😬, estás sem internet 📶. Ligue a internet no seu dispositivo e compre a subscrição ou plano final. E sejas feliz 😘.",
  parser: "Sem parceiro",
  premiumImages: "Seja Premium e Tenha acesso a mais avatares",
  duvidas: "Perguntas ou Sugestões - Desafios Picantes",
  description: "Olá, a minha pergunta ou sugestão é: ",
  texto99:
    "Se tiver algum problema ou sugestão envie-nos um e-mail clicando neste botão abaixo. Estamos ansiosos para falar contigo!",
  send: "Enviar",
  contact: "Contacto",
  botaoApple: "Restaurar compras",
  alertCompra: "A sua compra está a ser restaurada.",
  NotPurchase: "Não tens nenhuma compra",
  notPurchase2:
    "Este link destina-se apenas a utilizadores que tenham adquirido compras anteriores e que pretendam restaurar um novo dispositivo.",
  termOfPotitic: "Termos de Utilização e Política de Privacidade",
  alertDeuErrado: "Algo correu mal :(",
  alertDeuErrado2: "Preencha Todas as informações",
  alertNome: "Campo de preenchimento: Nome",
  options: "Opções",
  optionsTitle: "Opções",
  gradualGame: "Jogo Gradual",
  textoCaixa:
    "Ao ativar esta seleção, os desafios serão gradualmente, ou seja, dos mais leves aos mais extremos de acordo com a sua escolha.",
  comoJogar: "Como jogar? 🤔",
  avalie: "Avaliar",
  novaCategoria: "Minhas categorias",
  alterLanguage: "Mudar a linguagem?",
  textLanguage: "Quando alterar a linguagem a aplicação recomeçará",
  textLanguage1: "Mudar a linguagem?",
  cancel: "Cancelar",
  languages: "Idiomas",
  // email: "@email ✉️",
  deletCat: "Eliminar a categoria",
  textDeletCat:
    "Ao eliminar esta categoria, os desafios presentes nesta categoria serão eliminados. Depois desta ação, não pode mais ser desfeita.",
  deletDes: "Eliminar o desafio",
  textDeletDes:
    "Depois de eliminar o desafio, esta ação já não pode ser desfeita.",
  desafio: "Registar novo desafio",
  desafiotexto: "Desafio",
  textoeditDesafio: "Quem pode fazer isso?",
  textEmquem: "Em quem ?",
  nome: "Nome",
  inicio: "Comece o jogo",
  inicio2:
    "Ao premir este botão, você será levado para o ecrã de registo do jogador 👥.",
  inicio3: "Não demora muito para o jogo começar. 🎲",
  inicio4: "Seguinte",
  inicio5: "Comfigurações",
  inicio6: `Configurações como:: 
  
- Desafios progressivos
- Mudar a linguagem dos desafios 
- Criar desafios 
- Apoio 
- Entre outros.`,
  inicio7: "Fim",
  inicio8: `Seja Premium e tenha acesso a:

- Mais de 450 novos desafios 😎

- Personagens exclusivos 🦸‍♀️ 🧑‍🚒

- Crie os seus próprios desafios 📝

- Mantenha o jogo atualizado ✅

- E muito mais 😍`,
  inicio9: "Ajuda",
  inicio10: "Bem-vindo ao jogo Desafios Picantes 🌶",
  inicio11:
    "Veja como é fácil jogar e navegar menus em menos de 30 segundos 😎.",
  inicio12: "Ver tutorial 👍🏼",
  inicio13: "Não quero 👎🏼",
  inicio14: `Para começar o jogo é necessário adicionar pelo menos (2) dois jogadores 😀
              
Pressionando o botão indicado acima 👆
  
Sempre que adicionar um novo utilizador, este botão seja premida 😘`,
  cadastrarCategory: "Categoria Registro",
  inicio15: "Criação de uma nova categoria",
  inicio16:
    "Passo 1 : Pressione o botão com o sinal + que está localizado na parte inferior deste ecrã. Depois de premir uma janela, parece que entra na sua nova categoria.",
  inicio17: "Paso 2: Introduza a sua nova categoria e clique em guardar",
  inicio18:
    "Paso 3: Para editar esta categoria ou ADICIONAR OS DESAFIOS dentro da categoria pressione em cima dela.",
  inicio19:
    "Passo 4: No ecrã seguinte, premindo o botão indicado com a seta ⬆️ abrirá uma janela para a edição da sua nova categoria",
  inicio20:
    "Passo 5: No ecrã seguinte, premindo o botão indicado com a seta ⬆️ eliminará a categoria.",
  inicio21:
    "Passo 1: Pressione o botão abaixo para adicionar um novo desafio a esta categoria",
  inicio22: "Criando um novo desafio",
  inicio23:
    "Passo 2: Pressione em cima de cada item circulado para saber em detalhe cada campo do registo",
  inicio24: "Texto do desafio",
  inicio25: `Escreva o desafio ao seu gosto e para mostrar o nome do jogador no desafio basta premir o botão vermelho abaixo.. 
    
Irá adicionar os seguintes caracteres {nome} 

** NÃO ALTERE ESTES CARACTERES ** Pois para que seja exibido o nome de acordo, precisa ficar como descrito abaixo ⬇️⬇️⬇️⬇️

Desafio: Beije o pescoço de {nome}`,
  inicio26: "Quem pode fazê-lo e quem pode receber",
  inicio27: `Selecione "Ambos" se o desafio puder ser executado e recebido pelos participantes de "ambos" géneros.
  
Se o desafio for direcionado para um género, selecione o que quiser.
`,
  inicio28: "Adicionar tempo ao desafio",
  inicio29:
    'Se o seu desafio tiver um tempo basta arrastar o "intervalo" abaixo e o valor será apresentado acima. Depois do tempo acabar no desafio, um som irá tocar avisando que o desafio acabou.',
  aviso12: `Aqui cria-se apenas a categoria!
    
Para adicionar os desafios basta carregar no botão da sua categoria que acaba de ser criada ⬆️⬆️⬆️⬆️`,
  voltar: "Volta",
  semDe: "Jogador sem desafios",
  semDe2: `Registre pelo menos um desafio para este jogador 😬. 
  
Serás redirecionado para o ecrã de login`,
  term: "Privacidade",
  Potitic: "Termos de Utilização",
  adquirited: "Adquirido",
  camera: "Câmera",
  galery: "Galeria",
  avatar: "Avatar",
  image: "Imagem",
  seletion: " Selecionados",
  editCategory: "Editar a categoria",
  frase1: "Estás a gostar dos desafios?",
  frase2: "Queres experimentar os Desafios Premium?",
  //err texto
  errTexto:
    "Caso tenha encontrado algum erro de tradução, por favor corrija a frase no campo abaixo:",
  errTitulo: "Notou algo errado?",
  errCorrect: "Como seria em Protuguês ?",
  thisLanguageIsCorrect: "O desafio em PORTUGUÊS está correto?",
  yes: "Sim",
  no: "Não",
  errSend: "Enviar sugestão",

  share: "Compartilhar",
  fraseShare: `Que aplicativo Top! Só compartilhando porque sei que você também vai gostar!🫣
  Baixa aí e depois me conta se não é bom demais mesmo rs...😉
  
  
  Link para download: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇵🇹",
  morePlayer: "Jogar com mais jogadores ?",
  players: "Jugadores",
  carregar: "CARREGAR IMAGEM",
  takePhoto: "Tire uma foto ou selecione uma imagem",
  useAvatar: "OU USAR AVATARES",

  nomeHomem1: "Homem",
  nomeHomem2: "Homem",
  nomeMulher1: "Mulher",
  nomeMulher2: "Mulher",
  hetero: "Hétero",
  gay: "Gay",
  lesbico: "Lésbica",
  messageErr: "Adicione os jogadores 🙌",
  descricaoErr: "Digite os nomes dos participantes ✍️",
  why: "Nos diga o porque...",
  later: "Avaliar mais tarde",
  txtCard1: "Sua vez 🔥",
  txtCard2: "Faça acontecer 😘",
  txtCard3: "Vamos lá! 😜",
  txtCard4: "Próximo desafio 😈",
  txtCard5: "Mais um! 👄",

  tituloBloco1Novo: "Descubra a Intimidade Sexual com o seu Parceiro",
  subtitulo1Novo: "Mais de 1 milhão de casais satisfeitos",
  texto1Novo:
    "Destrave a intimidade e tenha acesso aos melhores jogos para casais! Desbloqueie agora todos os jogos, com diversas categorias criadas para vocês obterem o melhor da intimidade.",

  tituloBloco2Novo: "Novas experiências, melhor relacionamento",
  texto2Novo1: "Aproveite mais de 1500 desafios",
  texto2Novo2: "Sem anúncios",
  texto2Novo3: "Com Avatares",
  texto2Novo4: "Novos desafios todos os dias",
  texto2Novo5: "Novos Jogos regularmente",
  texto2Novo6: "Crie seus próprios desafios",
  texto2Novo7: "Categorias exclusivas",
  tituloBloco3Novo: "PONTUAÇÃO MÁXIMA NA CATEGORIA",
  tituloBloco4Novo: "Vantagens para a vossa relação:",
  texto4Novo1: "Intimidade",
  texto4Novo2: "Desejo",
  texto4Novo3: "Leveza",
  texto4Novo4: "Atração",
  texto4Novo5: "Ligação",
  texto4Novo6: "Prazer",

  tituloBloco5Novo: "Veja a opinião de outros casais",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Acho que esta é a melhor aplicação que encontrei para telemóvel até agora, tanto erótica como interessante. Nenhuma das outras aplicações que vi chega sequer perto, por isso arranjem um trabalho e comprem-na. Não se queixem por estarem sem dinheiro. Estão a perder coisas realmente boas aqui, e por apenas 10,00 $ podem ficar com a aplicação completa. Oferece experiências melhores do que os jogos que encontram nas lojas locais de prazer.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Esta aplicação é incrível! Estava na dúvida se devia ou não fazer o download, mas foi sem dúvida a melhor sensação que tivemos nos últimos tempos. É tão bom saber que ainda podemos fazer tantas coisas juntos. 🤭 Testámos a versão paga e vale mesmo a pena. Ainda não tínhamos atingido este nível de prazer.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Se quiserem apimentar a relação, esta aplicação é perfeita! Já tinha experimentado outras, mas nenhuma nos agradou tanto como esta. Os nossos preliminares foram muito mais quentes e agradáveis (imaginem o resto!). Vale mesmo a pena comprar a versão paga (se quiserem sentir um prazer mais intenso), mas a versão gratuita também nos surpreendeu bastante.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Excelente! Mesmo muito boa... Ficámos muito excitados durante o jogo, o que tornou o sexo muito mais envolvente – foi prazer por todo o lado! Já estamos ansiosos por jogar novamente 💦🔥. Recomendamos também a versão paga, se conseguirem aguentar tanto desejo 🤤.",
  tituloBloco6Novo:
    "Junte-se a centenas de casais em todo o mundo e dê um novo sabor à vossa vida amorosa. Descubram mais de 800 desafios exclusivos para casais.",
  texto6Select: "Selecione a versão:",
  texto6Premium: "Premium",
  texto6Assinatura: "Assinatura",
  texto6Mensal: "Mensal",
  texto6Anual: "Anual",
  texto6Vitalicia: "Subscrição Vitalícia",
  bePremium: "Seja Premium",
  buyNew: "Comece Agora",
  attention: "Atenção !",
  changeGender: "Você mudou sua orientação sexual",

  tituloAvaliacao: "Estás a gostar do jogo?",
  textoAvaliacao: "Avalia e ajuda-nos a melhorar!",
  agoraNão: "Agora não",
  enviarAvaliacao: "Enviar",

  nomeJogo1: "Desafios Picantes",
  nomeJogo2: "Verdade ou Consequência!?",
  nomeJogo3: "Nível de malícia",
  nomeJogo4: "Roleta do Sexo",
  nomeJogo5: "Dicas quentes",
  naughtyQuiz: "Questionário Malicioso",

  playAlone: "Jogar Sozinho",
  estaSozinho: "Estás sozinho?",
  selectPlayer: "Seleciona o jogador",

  skip: "Saltar",
  responder: "Enviar",
  respondaAqui: "Responde aqui",
  config4: "Escolha avatares para personalizar",

  tituloSelect1: "Estás a jogar sozinho?",
  tituloSelect2: "Responde a questões comprometedoras!",

  subTituloSelect1: "Damos-te uma ajuda!",
  subTituloSelect2: "Descobre o quão malicioso és!",
  txtJogador1:
    "Seleciona o teu jogador e explora prazeres guiados feitos só para ti!",
  txtJogador2: "O jogador selecionado responderá às questões",
  tituloCena: "QUE ITENS QUERES USAR?",
  subTituloCena:
    "Não tens algum? Toca em 'Obter' e adquire-o na loja parceira.",
  play: "Jogar",

  titleUserWarning: "Escolhe um utilizador",
  txtUserWarning: "Escolhe um utilizador para responder às questões",

  shareNivelDeSafadeza:
    "Ei, vê o meu nível de safadeza 😈 Experimenta momentos intensos de prazer. Experimente também 💋 Faça já o download da aplicação e prepare-se para desfrutar de desafios escaldantes 🔥 com o seu parceiro(a)!: ➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "Transforme a sua vida amorosa agora mesmo! Faça o download da aplicação e descubra o segredo para uma relação picante: ➡️ https://desafiospicantesapp.page.link/tipoftheday",

  resultadoQuiz1:
    "És uma pessoa reservada, não és muito fã de malandrice, preferes algo mais romântico!",
  resultadoQuiz2:
    "És demasiado romântico para abusar da malandrice, e preferes o ambiente à luz das velas.",
  resultadoQuiz3:
    "És uma pessoa bastante reservada e acreditas em manter as coisas mais discretas e privadas na vida íntima.",
  resultadoQuiz4:
    "Isso não significa que não sejas malicioso/a de vez em quando, mas preferes guardar todo esse fogo para gastar com alguém muito especial.",
  resultadoQuiz5:
    "O teu calor está em segundo plano, mas isso não muda o facto de que há calor",
  resultadoQuiz6:
    "Gostas de explorar novas experiências, mas sempre com respeito e consentimento.",
  resultadoQuiz7:
    "Adoras um encontro quente, cheio de beijos e muita pegação. No entanto, há uma parte de ti que também gosta de ver um filminho enquanto seguras a mão do teu/tua crush ou jantares à luz das velas.",
  resultadoQuiz8:
    "Estás disposto/a a experimentar coisas novas e emocionantes, mas sempre com responsabilidade.",
  resultadoQuiz9:
    "És uma pessoa ousada e gostas de apimentar as coisas na vida íntima de vez em quando.",
  resultadoQuiz10:
    "Gostas de desfrutar de todos os prazeres da vida e não tens limites quando o assunto é sexo.",
  resultadoQuiz11:
    'Contigo, não há hora errada, e a qualquer momento é hora para uma rapidinha! Filme romântico? Só se for "As Cinquenta Sombras de Grey"!',
  resultadoQuiz12:
    "Para ti, a intimidade é uma aventura constante, e não tens medo de correr riscos.",
  mes: "Mês",
  desafiosRestantesDois: "Tens 2 desafios Premium restantes!",
  nenhumDesafioRestante: "Nenhum desafio Premium restante!",
  tornePremiumAviso1:
    "Torna-te premium agora e desfruta de 1000 desafios Exclusivos!",
  tornePremiumAviso2:
    "Aproveita desafios ilimitados, conteúdo exclusivo e diversão sem interrupções!",
  conteudoPremium: "Selecionaste um conteúdo Premium!",
  aproveite4desafios:
    "Aproveita 4 desafios premium para experimentar um prazer exclusivo.",
  calculando: "A calcular resultados...",
  nivelRomantismo: "O teu nível de romantismo é...",
  finalizar: "Terminar",
  erroQuizTitulo: "Digite a sua resposta",
  erroQuizFrase: "Para avançar digite sua resposta!",
  new: "NOVO APP",

  //resposta quiz safadeza
  resQuiz1: "Soca fofo",
  resQuiz2: "Romantico",
  resQuiz3: "Sedutor",
  resQuiz4: "Safadão",

  texto6Semanal: "Semanal",
  weekly: "Assinatura Semanal",

  tempSemanal: "Cobrado semanalmente",
  tempMensal: "Cobrado mensalmente",
  tempAnual: "Cobrado anualmente",
  tempSempre: "Pagamento único",
  canceleAny: "Cancelar a qualquer momento",

  //Tela do safadrometro
  Low: "Fraco",
  Medium: "Mediano",
  High: "Alto",

  lifeTime: "Acesso vitalício",
  notNow: "Não agora, obrigado.",
  match: "COMBINA COM A I.A.",

  //Modal date
  dateTitle: "Quer conhecer nosso novo aplicativo?",

  dateBody: `Quer conversar com bots travessos 😈 e praticar sua paquera? Você vai se divertir!🔥`,
  goToDate: "Experimente o Date.AI agora!",

  goodForU: "FOI BOM PARA VOCÊ ?",
  rateOurPerformance: "Avalie nosso desempenho até aqui",
  veryGood: "Muito Bom",
  veryBad: "Muito Ruim",
  feedbackChallenge: `O que faria você compartilhar o app Desafios Picantes para outros casais e por que?`,
  type: "Digite sua resposta aqui...",
  survey: "Pesquisa de satisfação.",
  shareIfConfortable: "Se estiver confortável, compartilhe com amigos :)",

  howToPlay: "Como Jogar",
  howToPlayHotChallenge:
    "Prepara-te para apimentar as coisas! Tira uma carta de desafio e surpreende o teu parceiro com uma ação escaldante!",

  preGameTip1: "Acende as tuas paixões e cria momentos inesquecíveis juntos!",
  preGameTip2:
    "Explora os teus desejos mais selvagens e cria memórias inesquecíveis!",
  preGameTip3:
    "Liberta as tuas fantasias e desfruta de momentos de puro prazer!",
  preGameTip4:
    "Liberta os teus desejos e cria momentos inesquecíveis com o teu parceiro!",
  selecionajoagador: "Hora de jogar",
  dica: "Dica",
  howToPlayNaughty:
    "Escolha os seus brinquedos e objetos favoritos. Rode a roleta e deixe o destino escolher o seu próximo desafio atrevido!",
  howToPlayTruthOrDare:
    "Escolhe o teu destino: partilha uma verdade ou aceita um desafio ousado. Que a diversão comece!",
  howToKama1: "Descubra Posições do Prazer – 365 Dias de Paixão!",
  howToKama2:
    "Escolhe uma carta aleatória, tenta a posição e explora novos patamares de prazer juntos!",
  kamaExplain:
    "Desbloqueie uma nova posição todos os dias e construa a sua coleção definitiva de paixão – a sua jornada de 365 dias de prazer inesquecível começa aqui!",
  howToDo: "Como fazer",
  pergunta: "Pergunta",

  restart: "Recomeçar",
  dialogText1HotChallenges:
    "Você fez todos os desafios disponíveis com as categorias selecionados.",
  dialogText2HotChallenges:
    "Selecione mais categorias ou reinicie o jogo com os desafios atuais!",
  noChallenges: "Sem Desafios!",

  objects: "Objetos",
  dialogText1NaughtyGames:
    "Você fez todos os desafios disponíveis com os objetos selecionados.",
  dialogText2NaughtyGames:
    "Selecione mais objetos ou reinicie o jogo com os desafios atuais!",
  unlockPremium: "Desbloquear Premium",
  noCategory: "Por favor, escolhe pelo menos uma categoria para começar.",
  thanksForFeedback: "Obrigado por nos ajudar a melhorar a experiência!",
  categoryKamasutra: "Escolha a sua paixão e jogue!",
  tap: "Toque para revelar a sua posição!",
  step: "Guia Passo a Passo",
  shareQuizButton: "Partilha o teu nível de travessura!",
  tryAgain: "Tenta novamente",
  unlockAllFun: "Desbloqueia toda a diversão",
  limitedOffer: "Oferta especial por tempo limitado!",
  fill: "Preencha o seu nome e o do seu parceiro ou parceira.",

  kamaNotificationTitle: "🔥 A tua nova carta está desbloqueada!",
  kamaNotificationBody:
    "A tua posição do dia {variavel} está pronta. Que tal experimentar algo novo hoje? 💋",

  titleNewGame: "Prepare-se para o Roleplay!",
  phraseNewGame:
    "Na próxima atualização, um novo jogo para explorar as suas fantasias mais criativas está a chegar. Escolha personagens, crie histórias e eleve a diversão a um novo nível com o seu parceiro. 🔥",
  awaitNewGame: "Aguarde e prepare-se para viver momentos únicos!",

  selectObjects:
    "Seleciona dois ou mais itens para personalizar o teu jogo. Explora ao máximo.",
  soon: "Em breve",

  wantToBeNotify: "Eu quero ser notificado",
  ok: "OK",
  vezDe: "VEZ DE",

  categoryLabel: "Categoria",
  descriptionLabel: "Descrição",

  loginConnect: "Conectar-se",
  loginNoAccount: "Não tem uma conta?",
  loginCreateNow: "Crie agora",
  loginOrConnect: "ou conecte com",

  email: "Email",
  password: "Senha",
  loginRegister: "Registrar-se",
  loginAlreadyHas: "Já tem uma conta?",
  enterNow: "Entre agora",

  logout: "Sair",
  customerPortal: "Portal do Cliente",
  installApp: "Instalar Aplicativo",

  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/portugues-portugal.mp4",
};
